import { postApi } from './api_instance'

export const setPrimaryAccount = async (accountId, logout) => {
  try {
    const data = await postApi({
      apiUrl: `/admin/api/bankAccount/primary-admin/${accountId}`,
      sendToken: true,
      logout
    })
    return data
  } catch (error) {
    throw error
  }
}
